import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getDemoRequests, AdminDemoRequest } from '../../services/adminApi.ts';

const DemoRequestsPageContainer = styled.div`
  padding: 2rem;
  background-color: #f8f9fa;
  min-height: calc(100vh - 80px); /* Adjust based on header height */
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #343a40;
  margin-bottom: 2rem;
  text-align: center;
`;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
  }

  th {
    background-color: #e2e6ea;
    color: #495057;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.85rem;
  }

  tr:hover {
    background-color: #f1f3f5;
  }
`;

const NoDataMessage = styled.p`
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-size: 1.1rem;
`;

const ErrorMessage = styled.p`
  color: #dc3545;
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
`;

const LoadingMessage = styled.p`
  text-align: center;
  padding: 2rem;
  color: #007bff;
  font-size: 1.1rem;
`;

const DemoRequestsPage: React.FC = () => {
  const [demoRequests, setDemoRequests] = useState<AdminDemoRequest[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDemoRequests = async () => {
      try {
        const data = await getDemoRequests();
        setDemoRequests(data);
      } catch (err) {
        console.error('Error fetching demo requests:', err);
        setError('Failed to load demo requests. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchDemoRequests();
  }, []);

  if (loading) {
    return <LoadingMessage>Loading demo requests...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>{error}</ErrorMessage>;
  }

  return (
    <DemoRequestsPageContainer>
      <Title>Demo Requests</Title>
      {demoRequests.length === 0 ? (
        <NoDataMessage>No demo requests found.</NoDataMessage>
      ) : (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody>
              {demoRequests.map((request) => (
                <tr key={request.id}>
                  <td>{request.companyName}</td>
                  <td>{request.contactPerson}</td>
                  <td>{request.email}</td>
                  <td>{request.phoneNumber || 'N/A'}</td>
                  <td>{new Date(request.requestDate).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </TableContainer>
      )}
    </DemoRequestsPageContainer>
  );
};

export default DemoRequestsPage;
